import React from "react";
import Block5 from "../Block5";
import SubHeading from "../SubHeading";

const RelatedArticles = () => {
  return (
    <>
      {/* BLOCK */}
      <div className="p-4 md:p-0 mb-6">
        <SubHeading text="related articles" color="black" />

        <div className="flex flex-col md:flex-row justify-between">
          <div className="p-4"><Block5 /></div>
          <div className="p-4"><Block5 /></div>
          <div className="p-4"><Block5 /></div>
        </div>
      </div>
    </>
  );
};

export default RelatedArticles;
